<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'MOBILE_SETTINGS' }
  ]"
></breadcrumbs>

<page-header title="MOBILE_SETTINGS"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="LAYER">{{
        'LAYER' | translate
      }}</label>
      <div class="control">
        <ng-select
          [items]="activeLayers"
          name="SETTINGS_MOBILE_RESPONSIBILITY_LAYER"
          [multiple]="false"
          [closeOnSelect]="true"
          [ngClass]="{
            'is-danger': hasError('SETTINGS_MOBILE_RESPONSIBILITY_LAYER')
          }"
          bindLabel="name"
          bindValue="id"
          [ngModel]="getField(['SETTINGS_MOBILE_RESPONSIBILITY_LAYER'])"
          (change)="
            handleFieldChange(
              $event?.id,
              'SETTINGS_MOBILE_RESPONSIBILITY_LAYER'
            )
          "
          [ngModelOptions]="{ standalone: true }"
          class="is-small"
        >
        </ng-select>
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('SETTINGS_MOBILE_RESPONSIBILITY_LAYER')"
      >
        {{ getError('SETTINGS_MOBILE_RESPONSIBILITY_LAYER') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
